<template>
  <div data-testId="spinner">
    <dnl-icon
      icon="mdi-spinner"
      class="dnl:animate-spin dnl:w-full dnl:h-full"
    />
  </div>
</template>
